import React from "react";
import { Link } from "react-router-dom";
import "./DropDown.css";
export default function DropDown({ data, classto }) {
  return (
    <div className={classto}>
      <div className="dropDownItems">
        <ul className="dropDownItemsList">
          {data.map((data, index) => (
            <li key={index} className={data.classTo}>
              <img alt="img" src={data.img} className="listImg"></img>
              <Link to={data.target} className="DropDownLink">
                {data.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="dropDownFooter">
        <span className="footerText">Have an Idea to Discuss?</span>
        <Link href="/contact-us">
          <button className="footerBtn">Let's Talk</button>
        </Link>
      </div>
    </div>
  );
}
